import { useEffect } from 'react';

function useDialogBodyBlockScroll() {
    useEffect(() => {
        document.getElementsByTagName('body')[0].classList.add('dialog-block-scroll');

        return () => document.getElementsByTagName('body')[0].classList.remove('dialog-block-scroll');
    }, []);
}

export default useDialogBodyBlockScroll;
